export const defaultViewWrapperMarginBottom = '12px';
